import { AuthConfig } from 'angular-oauth2-oidc';
import { AppSettingsAuth } from 'src/settings/appsettings.interface';

export function getAuthConfig(config: AppSettingsAuth): AuthConfig {
  return new AuthConfig({
    issuer: config.issuer,
    clientId: config.clientId,
    responseType: 'code',
    scope: 'openid profile email offline_access',
    timeoutFactor: 0.75,
    useSilentRefresh: false,
    showDebugInformation: false,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    customQueryParams: {
      audience: config?.audience ?? undefined,
    },
  });
}
